"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuantityPickerClickedEvent = exports.Name = void 0;
const Name = exports.Name = 'quantity-picker-clicked';
const QuantityPickerClickedEvent = exports.QuantityPickerClickedEvent = Name;
